import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";
import React from "react";
import isGHMC, { formattedDate, getCurrentDateTime1 } from "../../../Common/helper/helpar";
import { GetZone } from "../../../Apis/organizationApi";
import { TableLoader } from "../../../Common/ShimmerLoader";
import { useState } from "react";
import ExcelJS from "exceljs";
import { useEffect } from "react";
import CommercialCollectionReportStore from "./store/commercialCollectionStore";
const CommercialCollectionReport = () => {
    const isProd = isGHMC();
    const { fetchCommercialCollectionReportsApi, commercialReportsData, loading } = CommercialCollectionReportStore()
    const headerStyles = {
        textAlign: "center",
        border: "1px solid #ddd",
        borderRight: "none",
        padding: "10px",
        color: "#fff",
        backgroundColor: isProd ? "#043555" : "#EC1117",
    };

    const cellStyles = {
        textAlign: "center",
        border: "1px solid #ddd",
        borderRight: "none",
        padding: "10px",
        whiteSpace: "normal",
    };

    const dateCellStyles = {
        textAlign: "center",
        border: "1px solid #ddd",
        borderRight: "none",
        padding: "10px",
        whiteSpace: "normal",
        minWidth: "120px", // Increased width for date column
        width: "120px",
    };

  const formatDateForDisplay = (dateString) => {
    if (!dateString || isNaN(new Date(dateString).getTime())) {
        return "N/A";
    }

    const date = new Date(dateString);
    const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    };
    return date.toLocaleString("en-GB", options).replace(",", "");
};


    const [startDate, setStartDate] = useState(getStartOfCurrentDate());
    const [endDate, setEndDate] = useState(getCurrentDateTime());
    const [vehicleNumber, setVehicleNumber] = useState("");
    const [allZones, setAllZones] = useState("");
    const [zoneId, setZoneId] = useState("");

    const fetchAllZoneData = async () => {
        try {
            const zonesData = await GetZone();
            setAllZones(zonesData);
        } catch (error) {
            console.error("Error fetching initial data:", error);
        }
    };

    useEffect(() => {
        fetchAllZoneData();
        fetchCommercialCollectionReportsApi(startDate, endDate, zoneId, vehicleNumber);
    }, []);



    const handleFormSubmit = (e) => {
        e.preventDefault();
        fetchCommercialCollectionReportsApi(startDate, endDate, zoneId, vehicleNumber);
    };


    const options = { day: "numeric", month: "numeric", year: "numeric" };
    const generationTime = ` ${new Date().toLocaleString("en-GB", options).replace(/\//g, "/")}`;
 const downloadAsExcel = async () => {
  const currentDate = new Date();
  const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
  const cumulativeHeadingReport = `Commercial Collection Report ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)} - (at ${getCurrentDateTime1()})`;
  const downloadDateTime = `Report on: ${generationTime}, ${formattedTime}`;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Commercial Collection Report");

  const boldFont = { bold: true };
  const centerAlign = { horizontal: "center", vertical: "middle", wrapText: true };
  const headerFill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "F6B1B1" }, // Light gray
  };
  const borderStyle = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Row 1
  worksheet.mergeCells("A1:Z1");
  const cellA1 = worksheet.getCell("A1");
  cellA1.value = downloadDateTime;
  cellA1.font = boldFont;
  cellA1.alignment = centerAlign;
  cellA1.border = borderStyle;

  // Row 2
  worksheet.mergeCells("A2:Z2");
  const cellA2 = worksheet.getCell("A2");
  cellA2.value = cumulativeHeadingReport;
  cellA2.font = boldFont;
  cellA2.alignment = centerAlign;
  cellA2.border = borderStyle;

  // Row 3
  const headerCells = ["A3", "B3", "C3", "D3", "E3", "F3", "G3", "Q3"];
  worksheet.mergeCells("A3:A5"); worksheet.getCell("A3").value = "S.No";
  worksheet.mergeCells("B3:B5"); worksheet.getCell("B3").value = "Zone";
  worksheet.mergeCells("C3:C5"); worksheet.getCell("C3").value = "Date";
  worksheet.mergeCells("D3:D5"); worksheet.getCell("D3").value = "Type of Vehicle";
  worksheet.mergeCells("E3:E5"); worksheet.getCell("E3").value = "Vehicle No";
  worksheet.mergeCells("F3:F5"); worksheet.getCell("F3").value = "Ward No";
  worksheet.mergeCells("G3:P3"); worksheet.getCell("G3").value = "PRIMARY COLLECTION";
  worksheet.mergeCells("Q3:AC3"); worksheet.getCell("Q3").value = "PLANNED NO. OF TRIPS";

  headerCells.forEach(cell => {
    const c = worksheet.getCell(cell);
    c.font = boldFont;
    c.alignment = centerAlign;
    c.fill = headerFill;
    c.border = borderStyle;
  });

  // Row 4: TRIP headers
  const primaryTripHeaders = ["TRIP 1", "TRIP 2", "TRIP 3", "TRIP 4", "TRIP 5"];
  primaryTripHeaders.forEach((trip, i) => {
    const col = 7 + i * 2;
    worksheet.mergeCells(4, col, 4, col + 1);
    const cell = worksheet.getCell(4, col);
    cell.value = trip;
    cell.font = boldFont;
    cell.alignment = centerAlign;
    cell.fill = headerFill;
    cell.border = borderStyle;
  });

  // Row 4: Planned Trips
  worksheet.mergeCells("Q4:R4");
  const trip1 = worksheet.getCell("Q4");
  trip1.value = "TRIP 1";
  trip1.font = boldFont;
  trip1.alignment = centerAlign;
  trip1.fill = headerFill;
  trip1.border = borderStyle;

  ["TRIP 2", "TRIP 3", "TRIP 4", "TRIP 5"].forEach((trip, i) => {
    const start = 19 + i;
    worksheet.mergeCells(4, start, 4, start);
    const cell = worksheet.getCell(4, start);
    cell.value = trip;
    cell.font = boldFont;
    cell.alignment = centerAlign;
    cell.fill = headerFill;
    cell.border = borderStyle;
  });

  // Row 5: Subheaders
  worksheet.getRow(5).values = [
    "", "", "", "", "", "",
    "Route SP Reporting Time", "Route EP Reporting Time",
    "Route SP Reporting Time", "Route EP Reporting Time",
    "Route SP Reporting Time", "Route EP Reporting Time",
    "Route SP Reporting Time", "Route EP Reporting Time",
    "Route SP Reporting Time", "Route EP Reporting Time",
    "Unloading Location", "Date & Time",
    "Date & Time", "Date & Time", "Date & Time", "Date & Time"
  ];

  worksheet.getRow(5).eachCell(cell => {
    cell.font = boldFont;
    cell.alignment = centerAlign;
    cell.fill = headerFill;
    cell.border = borderStyle;
  });

  // Data rows
  commercialReportsData.forEach((item, index) => {
    worksheet.addRow([
      index + 1,
      item.zoneName || "N/A",
      formattedDate(item.date) || "N/A",
      item.typeOfVehicle || "N/A",
      item.vehicleNo || "N/A",
      item.wardNumber || "N/A",
      formatDateForDisplay(item.trip1_SP_ReportingTime) || "N/A",
      formatDateForDisplay(item.trip1_EP_ReportingTime) || "N/A",
      formatDateForDisplay(item.trip2_SP_ReportingTime) || "N/A",
      formatDateForDisplay(item.trip2_EP_ReportingTime) || "N/A",
      formatDateForDisplay(item.trip3_SP_ReportingTime) || "N/A",
      formatDateForDisplay(item.trip3_EP_ReportingTime) || "N/A",
      formatDateForDisplay(item.trip4_SP_ReportingTime) || "N/A",
      formatDateForDisplay(item.trip4_EP_ReportingTime) || "N/A",
      formatDateForDisplay(item.trip5_SP_ReportingTime) || "N/A",
      formatDateForDisplay(item.trip5_EP_ReportingTime) || "N/A",
      item.transferStationName || "N/A",
      formatDateForDisplay(item.tsInTime1) || "N/A",
      formatDateForDisplay(item.tsInTime2) || "N/A",
      formatDateForDisplay(item.tsInTime3) || "N/A",
      formatDateForDisplay(item.tsInTime4) || "N/A",
      formatDateForDisplay(item.tsInTime5) || "N/A",
    ]);
  });

  worksheet.columns = new Array(23).fill({ width: 20 });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "Commercial Collection Report.xlsx";
  a.click();
  URL.revokeObjectURL(url);
};



    return (
        <div style={{ width: "100%" }}>
            <div className="content mb-3">
                <div className="page-content">
                    <h4 className="text-start mb-3">
                        <span>Commercial Collection Report {formatDateForDisplay(startDate)} to {formatDateForDisplay(endDate)} - (at {getCurrentDateTime1()})</span>
                    </h4>
                    <div className="page-header text-start">
                        <div className="card">
                            <div className="card-body p-3">
                                <div className="row align-items-end mb-3">
                                    <div className="col-md-12">
                                        <form onSubmit={handleFormSubmit}>
                                            <div className="row" style={{ textAlign: "left" }}>
                                                <div className="col-md-2">
                                                    <label>From Date & Time:</label>
                                                    <input
                                                        type="datetime-local"
                                                        name="FromDate"
                                                        style={inputStyle}
                                                        value={startDate}
                                                        className="form-control"
                                                        max={endDate ? endDate : getCurrentDateTime()}
                                                        onChange={(e) => setStartDate(e.target.value)}
                                                    />
                                                </div>
                                                <div className="col-md-2">
                                                    <label>To Date & Time:</label>
                                                    <input
                                                        type="datetime-local"
                                                        name="ToDate"
                                                        style={inputStyle}
                                                        value={endDate}
                                                        className="form-control"
                                                        min={startDate}
                                                        max={getCurrentDateTime()}
                                                        onChange={(e) => setEndDate(e.target.value)}
                                                    />
                                                </div>
                                                <div className="col-md-2">
                                                    <label>Vehicle Number</label>
                                                    <input
                                                        type="text"
                                                        name="vehicleTypeCode"
                                                        style={inputStyle}
                                                        placeholder="Vehicle Number"
                                                        className="form-control"
                                                        value={vehicleNumber}
                                                        onChange={(e) => {
                                                            setVehicleNumber(e.target.value.replace(/\s+/g, ""));
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="ZoneId">Zone:</label>
                                                    <select
                                                        name="ZoneId"
                                                        className="form-select"
                                                        value={zoneId}
                                                        onChange={(e) => setZoneId(e.target.value)}
                                                    >
                                                        <option value="">Select</option>
                                                        {allZones &&
                                                            allZones
                                                                ?.filter((zone) => zone.isActive)
                                                                .map((zone) => (
                                                                    <option key={zone.zoneId} value={zone.zoneId}>
                                                                        {zone.zoneName}
                                                                    </option>
                                                                ))}
                                                    </select>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="d-flex justify-content-between">
                                                        <button
                                                            type="submit"
                                                            className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                                                        >
                                                            Search
                                                        </button>
                                                        <button className="btn btn-excel ms-auto mt-4"
                                                            onClick={downloadAsExcel}
                                                        >
                                                            <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <TableContainer
                                    component={Paper}
                                    sx={{
                                        width: "100%",
                                        border: "1px solid #ccc",
                                        maxHeight: 700,
                                    }}
                                >
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead
                                            className={`${isProd ? "bg-ghmc" : "bg-swm"}`}
                                            style={{ position: "sticky", top: 0 }}
                                        >
                                            <TableRow>
                                                <TableCell rowSpan={3} sx={headerStyles}>S.No</TableCell>
                                                <TableCell rowSpan={3} sx={headerStyles}>Zone</TableCell>
                                                <TableCell rowSpan={3} sx={headerStyles}>Date</TableCell>
                                                <TableCell rowSpan={3} sx={headerStyles}>Type of Vehicle</TableCell>
                                                <TableCell rowSpan={3} sx={headerStyles}>Vehicle No</TableCell>
                                                <TableCell rowSpan={3} sx={headerStyles}>Ward Name</TableCell>
                                                <TableCell colSpan={10} sx={headerStyles}>PRIMARY COLLECTION</TableCell>
                                                <TableCell colSpan={6} sx={headerStyles}>PLANNED NO. OF TRIPS</TableCell>
                                            </TableRow>

                                            <TableRow>
                                                {[1, 2, 3, 4, 5].map((trip) => (
                                                    <React.Fragment key={`trip-${trip}`}>
                                                        <TableCell colSpan={2} sx={headerStyles}>TRIP {trip}</TableCell>
                                                    </React.Fragment>
                                                ))}
                                                <TableCell colSpan={2} sx={headerStyles}>TRIP 1</TableCell>
                                                {[2, 3, 4, 5].map((trip) => (
                                                    <React.Fragment key={`planned-${trip}`}>
                                                        <TableCell colSpan={1} sx={headerStyles}>TRIP {trip}</TableCell>
                                                    </React.Fragment>
                                                ))}
                                            </TableRow>

                                            <TableRow>
                                                {[1, 2, 3, 4, 5].map((trip) => (
                                                    <React.Fragment key={`actual-time-${trip}`}>
                                                        <TableCell sx={headerStyles}>Route SP Reporting Time</TableCell>
                                                        <TableCell sx={headerStyles}>Route EP Reporting Time</TableCell>
                                                    </React.Fragment>
                                                ))}
                                                <TableCell sx={headerStyles}>Unloading Location</TableCell>
                                                <TableCell sx={headerStyles}>Date & Time</TableCell>
                                                {[2, 3, 4, 5].map((trip) => (
                                                    <React.Fragment key={`planned-time-${trip}`}>
                                                        <TableCell sx={headerStyles}>Date & Time</TableCell>
                                                    </React.Fragment>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {commercialReportsData?.length > 0 ? (
                                                commercialReportsData.map((item, index) => (
                                                    <TableRow
                                                        key={index}
                                                        sx={{
                                                            backgroundColor: isProd
                                                                ? index % 2 === 1 ? "rgba(4, 53, 85, 0.04)" : "#ffffff"
                                                                : index % 2 === 1 ? "rgba(4, 53, 85, 0.04)" : "#ffffff",
                                                        }}
                                                    >
                                                        <TableCell sx={cellStyles}>{index + 1}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.zoneName || "N/A"}</TableCell>
                                                        <TableCell sx={dateCellStyles}>{formattedDate(item.date) || "N/A"}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.typeOfVehicle || "N/A"}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.vehicleNo || "N/A"}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.wardNumber || "N/A"}</TableCell>

                                                        {/* PRIMARY COLLECTION REPORT */}
                                                        <TableCell sx={cellStyles}>{formatDateForDisplay(item.trip1_SP_ReportingTime) || "N/A"}</TableCell>
                                                        <TableCell sx={cellStyles}>{formatDateForDisplay(item.trip1_EP_ReportingTime) || "N/A"}</TableCell>
                                                        <TableCell sx={cellStyles}>{formatDateForDisplay(item.trip2_SP_ReportingTime) || "N/A"}</TableCell>
                                                        <TableCell sx={cellStyles}>{formatDateForDisplay(item.trip2_EP_ReportingTime) || "N/A"}</TableCell>
                                                        <TableCell sx={cellStyles}>{formatDateForDisplay(item.trip3_SP_ReportingTime) || "N/A"}</TableCell>
                                                        <TableCell sx={cellStyles}>{formatDateForDisplay(item.trip3_EP_ReportingTime) || "N/A"}</TableCell>
                                                        <TableCell sx={cellStyles}>{formatDateForDisplay(item.trip4_SP_ReportingTime) || "N/A"}</TableCell>
                                                        <TableCell sx={cellStyles}>{formatDateForDisplay(item.trip4_EP_ReportingTime) || "N/A"}</TableCell>
                                                        <TableCell sx={cellStyles}>{formatDateForDisplay(item.trip5_SP_ReportingTime) || "N/A"}</TableCell>
                                                        <TableCell sx={cellStyles}>{formatDateForDisplay(item.trip5_EP_ReportingTime) || "N/A"}</TableCell>

                                                        {/* PLANNED TRIP 1 (2 columns) */}
                                                        <TableCell sx={cellStyles}>{item.transferStationName || "N/A"}</TableCell>
                                                        <TableCell sx={cellStyles}>{formatDateForDisplay(item.tsInTime1 || "N/A")}</TableCell>
                                                        <TableCell sx={cellStyles}>{formatDateForDisplay(item.tsInTime2 || "N/A")}</TableCell>
                                                        <TableCell sx={cellStyles}>{formatDateForDisplay(item.tsInTime3 || "N/A")}</TableCell>
                                                        <TableCell sx={cellStyles}>{formatDateForDisplay(item.tsInTime4 || "N/A")}</TableCell>
                                                        <TableCell sx={cellStyles}>{formatDateForDisplay(item.tsInTime5 || "N/A")}</TableCell>
                                                        {/* PLANNED TRIPS 2 to 5 (1 column each) */}

                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell sx={cellStyles} colSpan={25}>
                                                        <strong>No Data Available</strong>
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommercialCollectionReport;


// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hour}:${minute}`;
};

// Styles for input and button
const inputStyle = {
    border: "1px solid #E2E2E2",
    padding: "15px",
};

const buttonStyle = {
    border: "1px solid #E2E2E2",
    borderRadius: "5px",
    color: "#fff",
};